export const initialStates = {
  voucher_select: { voucher: '' },
  playground: {
    spinner: 1,
    range_slider: 75
  },
  registration: {
    outlet_validation: {
      customer_number: '',
      eircode_or_passcode: ''
    },
    account_manager_validation: {
      ho_number: '',
      email: ''
    }
  },
  yourStore: {
    customer_number: '',
    updated_name: '',
    updated_address_1: '',
    updated_address_2: '',
    updated_address_3: '',
    updated_town: '',
    updated_country: '',
    updated_eircode: '',
    voucher_type_id: null,
    dont_know_eircode: false
  },
  login: {
    login: '',
    password: ''
  },
  resetPW: {
    step1: {
      email: '',
      mobile: ''
    },
    step2: {
      pin: ''
    },
    step3: {
      answer1: '',
      answer2: ''
    },
    step4: {
      password: '',
      password_confirmation: ''
    }
  },
  staff_member: {
    title: '',
    job_title: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    outlet_id: '',
    permission_ids: {},
    agreed: false
  },
  store: {
    staff_member: {
      title: '',
      first_name: '',
      last_name: '',
      email: '',
      mobile: '',
      outlet_id: '',
      permission_ids: {}
    }
  },
  store_summary: [],
  about_you: {
    marketing_consent: {
      marketing_accepted: null,
      marketing_accepted_confirm: null
    },
    user: {
      id: '',
      title: '',
      job_title: '',
      first_name: '',
      last_name: '',
      date_of_birth: '',
      gender: 'male',
      marketing_accepted: null,
      personal_address_1: '',
      personal_address_2: '',
      personal_address_3: '',
      personal_address_4: '',
      personal_eircode: '',
      comms_email: false,
      email: null,
      comms_mobile: false,
      mobile: null,
      password: '',
      password_confirmation: '',
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: ''
        },
        {
          security_question_id: '',
          answer: ''
        }
      ],
      t_cs1: false,
      t_cs2: true
    }
  },
  updatePw: {
    user: {
      current_password: '',
      password: '',
      password_confirmation: ''
    }
  },
  updateSecQ: {
    user: {
      current_password: '',
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: ''
        },
        {
          security_question_id: '',
          answer: ''
        }
      ]
    },
    owner: {
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: '',
          id: ''
        },
        {
          security_question_id: '',
          answer: '',
          id: ''
        }
      ]
    }
  },
  my_profile: {
    personal_address_1: '',
    personal_address_2: '',
    personal_address_3: '',
    personal_address_4: '',
    personal_eircode: '',
    billing_address_1: '',
    billing_address_2: '',
    billing_address_3: '',
    billing_address_4: '',
    billing_eircode: '',
    comms_email: false,
    comms_mobile: false,
    email: '',
    mobile: '',
    marketing_accepted: false
  },
  order: {
    confirm: {
      outlet_id: '',
      your_reference: '',
      delivery_date: '',
      line_items_attributes: []
    }
  },
  contact_us: {
    title: '',
    name: '',
    store_name: '',
    email: '',
    telephone: '',
    type_of_enquiry: '',
    message: ''
  },
  admin_my_profile: {
    first_name: '',
    last_name: '',
    title: '',
    comms_email: false,
    comms_mobile: false,
    email: '',
    mobile: ''
  },
  admin_edit_user: {
    title: '',
    first_name: '',
    last_name: '',
    usergroup: '',
    comms_email: false,
    email: '',
    status: '',
    locked: 'no'
  },
  admin_welcome: {
    password: '',
    password_confirmation: '',
    t_cs1: false,
    t_cs2: false,
    invitation_token: '',
    security_answers_attributes: [
      {
        security_question_id: '',
        answer: ''
      },
      {
        security_question_id: '',
        answer: ''
      }
    ]
  },
  admin_usergroup: {
    name: '',
    permission_ids: {}
  },
  admin_notification_edit: {
    event: '',
    to_associated_user: 'true',
    custom_to: '',
    email: false,
    email_subject: '',
    email_body: '',
    sms: false,
    sms_body: '',
    site_message: false,
    site_body: ''
  },
  admin_user: {
    details: {
      title: '',
      first_name: '',
      last_name: '',
      date_of_birth: '',
      personal_address_1: '',
      personal_address_2: '',
      personal_address_3: '',
      personal_address_4: '',
      personal_eircode: '',
      comms_email: false,
      comms_mobile: false,
      email: '',
      mobile: '',
      status: '',
      account_locked: ''
    },
    edit: {
      title: '',
      first_name: '',
      last_name: '',
      comms_email: 'true',
      email: '',
      status: '',
      account_locked: '',
      user_group_id: ''
    }
  },
  page: {
    name: '',
    page_template: '',
    login_required: ''
  },
  admin_delink: {
    delink_date: '',
    delink_reason: '',
    outlet: '',
    supress_notification: false
  },
  admin_category: {
    name: ''
  },
  admin_brand: {
    name: '',
    categories: [],
    status: '',
    banner_title: '',
    banner_text: ''
  },
  admin_order_limit: {
    categories: [],
    active: '',
    start_date: '',
    end_date: ''
  },
  admin_outlet_view: {
    auto_redeem: false,
    voucher_denomination_id: '',
    voucher_type_id: '',
    reward_markup: 99,
    use_delivery_address: false
  },
  admin_product_save: {
    name: '',
    status: 'ACTIVE',
    special_new: true,
    special_featured: false,
    special_reward: true,
    exclude_from_marketing: false,
    sku: '',
    ean: '',
    category_id: '',
    brand_id: '',
    group_ids: [],
    rsp: '',
    outer_price: 0,
    units_per_outer: 0,
    tar: '',
    nicotine: '',
    flavour: '',
    max_per_order: 0,
    minimum_order_quantity: 0,
    stock_status: 'In Stock',
    photo: '',
    wording: '',
    marketing_text: '',
    marketing_text_color: '',
    marketing_title: ''
  },
  admin_promotion_save: {
    product_id: '',
    display_from_date: '',
    display_to_date: '',
    group_ids: [],
    outer_price: 0
  },
  admin_promotional_banner_save: {
    name: '',
    image: '',
    default: '',
    display_from_date: '',
    display_to_date: '',
    group_ids: []
  },
  admin_upsell_popup_save: {
    title: '',
    image: '',
    wording: '',
    product_ids: []
  },
  admin_group_save: {
    name: ''
  },
  admin_ho_account_save: {
    ho_account_number: '',
    active: 'true'
  },
  admin_feature_toggle_save: {
    name: '',
    description: '',
    enabled: 'false'
  },
  admin_assessment_save: {
    name: '',
    start_date: '',
    end_date: '',
    criteria: '',
    display_from_date: '',
    display_to_date: ''
  },
  admin_account_manager_save: {
    account_manager_code: '',
    email: '',
    voucher_type_id: ''
  },
  admin_game: {
    name: '',
    start_date: '',
    end_date: '',
    banner: '',
    background: '',
    has_no_levels: 'false',
    group_ids: [],
    product_ids: [],
    game_levels: {}
  },
  admin_ppc: {
    settings: {
      autoload_date: '',
      autoload_dates: [],
      kyc_limit_euro: '',
      load_fee_percent: '',
      points_per_euro: '',
      ppc_management_url: ''
    },
    management: {
      user: {
        title: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        address_1: '',
        address_2: '',
        town: '',
        county: '',
        eircode: '',
        kyc_status: '',
        email: '',
        mobile: ''
      },
      load: {
        points: 0,
        value: 0,
        status: ''
      },
      manual_load: {
        points: 0,
        value: 0
      }
    }
  },
  incentives: {
    name: '',
    start_date: '',
    end_date: '',
    kind: '',
    audience: '',
    reward_type: '',
    target: '',
    default_target: '',
    maximum_points: '',
    points_to_target: '',
    points_to_target_2: '',
    points_after_target: '',
    display_from: '',
    display_to: '',
    product_ids: [],
    percentage_calculate_from: '',
    percentage_calculate_to: '',
    start_date_before_current_date: '',
    prize_name: '',
    prize_description: '',
    prize_image_link: '',
    prize_image_uid: ''
  },
  stock_it_incentives: {
    name: '',
    start_date: '',
    end_date: '',
    product_ids: [],
    start_date_before_current_date: '',
    target: ''
  },
  admin_staff_reward: {
    settings: {
      point_per_euro: '',
      reward_markup: '',
      available_vouchers: [],
      autoredemption_date: '',
      autoredemption_dates: []
    }
  },
  admin_news: {
    category: {
      name: ''
    },
    article: {
      title: '',
      news_category_id: 0,
      status: '',
      display_from_date: '',
      display_to_date: '',
      featured: '',
      permission_ids: [],
      linked_article_ids: [],
      group_ids: []
    }
  },
  admin_files: {
    upload: {},
    edit: {
      name: ''
    }
  },
  points_expiry: {
    id: '',
    day: '',
    month: ''
  },
  user_point: {
    value: '',
    description: '',
    customer_number: ''
  },
  home_page_carousel: {
    position: '',
    live: '',
    title: '',
    text: '',
    text_color: '',
    button_color: '',
    button_text_color_when_hover: '',
    button_label: '',
    image: '',
    button_link: '',
    permission_ids: {},
    all_groups: false,
    group_ids: [],
    css_tag_attributes: {
      id: '',
      content: '',
      asset_type: ''
    },
    javascript_tag_attributes: {
      id: '',
      content: '',
      asset_type: ''
    }
  },
  home_page_carousel_setting: {
    slide_speed: ''
  },
  personal_rewards: {
    title: '',
    first_name: '',
    last_name: '',
    date_of_birth: '',
    address_1: '',
    address_2: '',
    town: '',
    county: '',
    eircode: '',
    store_name: '',
    email: '',
    mobile: '',
    accept_terms: false
  },
  staff_rewards: {
    auto_redeem: false,
    voucher_type_id: '',
    voucher_denomination_id: ''
  },
  tile: {
    link: '',
    label: '',
    button_color: '',
    default_image: '',
    image: ''
  },
  point_statement: {
    outlet_id: '',
    transaction_type: '',
    date_from: '',
    date_to: ''
  },
  limitedRewardCalculation: {
    requestedVoucherValue: '',
    manualRedemptionTermsAccepted: false
  },
  replacementProducts: {},
  prize: {
    name: '',
    description: '',
    outlet_id: '',
    incentive_id: '',
    value: '',
    award_date: ''
  },
  stock_it_incentives_outlet_visit_data: {
    visit_date: ''
  },
  points_transfer: {
    staff_member: '',
    euro: ''
  }
};



// WEBPACK FOOTER //
// ./src/initialStates.js